'use client'

interface IconArticleVideoPlayProps extends SVGComponentProps {
	size?: 'lg' | 'md'
}
const IconArticleVideoPlay = ({ size = 'lg', ...props }: IconArticleVideoPlayProps) => {
	return size === 'lg' ? (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="56"
			height="57"
			viewBox="0 0 56 57"
			fill="none"
			className={props.className}
		>
			<path
				d="M49.5887 27.4558C50.3652 27.9047 50.3659 29.0254 49.5899 29.4753L8.75182 53.1509C7.97405 53.602 7 53.0408 7 52.1418V28.4645V4.85542C7 3.95701 7.97284 3.39573 8.75061 3.84541L49.5887 27.4558Z"
				fill="white"
			/>
		</svg>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="49"
			height="48"
			viewBox="0 0 49 48"
			fill="none"
			className={props.className}
		>
			<path
				d="M43.0046 23.1049C43.6702 23.4897 43.6708 24.4503 43.0056 24.8359L8.00156 45.1293C7.3349 45.5159 6.5 45.0349 6.5 44.2643V23.9695V3.73318C6.5 2.96312 7.33386 2.48202 8.00052 2.86746L43.0046 23.1049Z"
				fill="white"
			/>
		</svg>
	)
}

export default IconArticleVideoPlay
